<div class="page-outer-wrapper">

  <div class="admin-page-header">
    <div class="hamburger">
      <img (click)="toggleSidebar()" style="cursor: pointer;" src="/assets/images/menu-512.png" height="28" width="28">
    </div>
    <div id="nav-bar" class="nav-bar">
    </div>
  </div>

  <div class="page-content-background">

    <div class="page-content">

      <mat-sidenav-container id="admin-content-wrapper" class="admin-content-wrapper">

        <mat-sidenav #adminsidenav class="admin-sidebar">

          <admin-sidebar></admin-sidebar>

        </mat-sidenav>

        <mat-sidenav-content>

          <!-- [START] page content -->

          <mat-card style="width: 100%; display: block;">

            <mat-card-header>
              <mat-card-title>Sync Jobs</mat-card-title>
            </mat-card-header>

            <mat-card-content style="padding-left: 16px;">

              <p style="width: 650px;">Use the SYNC button below to import the latest panorama data from BigQuery
                into the local PostgreSQL database.
              </p>

              <div style="clear: both; margin-top: 12px;">

                <div style="width: 100%; clear: both; margin-bottom: 12px;">
                  <p-button label="Sync" [disabled]="!enabled" (click)="sync()"></p-button>
                </div>

                <div style="clear: both;">

                  <p-accordion class="admin-dark-accordion">

                    <!-- the next job panel -->

                    <p-accordionTab *ngFor="let j of presentation">

                      <!-- header of panel -->

                      <ng-template pTemplate="header">
                        <span class="sjpanelheader" [innerHTML]="j.header"></span>
                      </ng-template>

                      <ng-template pTemplate="content">
                        <span class="sjpanelcontent" [innerHTML]="j.body"></span>
                      </ng-template>

                    </p-accordionTab>

                  </p-accordion>

                </div>

              </div>


            </mat-card-content>

          </mat-card>

        </mat-sidenav-content>

      </mat-sidenav-container>

    </div>

    <div id="pano-footer" class="pano-footer"></div>

  </div>

</div>
